export default "__VITE_ASSET__CA3CM1mK__"